import React from 'react';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import styles from './Dispositivos_Logs.module.less';

const levelsDict = (t) => ({
  0: t('tables.logs.rows.level.not_assigned'),
  1: t('tables.logs.rows.level.debug'),
  2: t('tables.logs.rows.level.info'),
  3: t('tables.logs.rows.level.warning'),
  4: t('tables.logs.rows.level.error'),
  5: t('tables.logs.rows.level.critical'),
});

function getColumnsLogs({ setSelectedItem, t }) {

  return [
    {
      key: 'date',
      title: t('tables.logs.columns.date'),
      dataIndex: 'date',
      render: (time) => dayjs(time).format('YYYY/MM/DD - HH:mm'),
    },
    {
      key: 'device',
      title: t('tables.logs.columns.imei'),
      dataIndex: 'device',
    },
    {
      key: 'resetStatus',
      title: t('tables.logs.columns.resetStatus'),
      dataIndex: 'resetStatus',
    },
    {
      key: 'systemStatus',
      title: t('tables.logs.columns.systemStatus'),
      dataIndex: 'systemStatus',
    },
    {
      title: t('tables.logs.columns.systemDetail'),
      width: 160,
      fixed: 'right',
      render: (_, record) => {

        const id = `edit_${record.id}`;
        return (
        // eslint-disable-next-line react/jsx-filename-extension
          <div key={id}>
            <FontAwesomeIcon
              className={styles.faEye}
              icon={faEye}
              onClick={() => setSelectedItem(record)}
            />
          </div>
        );

      },
    },
  ];

}

export default getColumnsLogs;
export { levelsDict };
